<script>
  import { fade } from "svelte/transition"
  export let option
</script>

{#if option}
  <tr transition:fade>
    <th>{option.option_type.presentation}</th>
    <td class="capitalize">
      {@html option.presentation}
    </td>
  </tr>
{/if}
